export function getIconFromMenu(menuOption) {
    let icon = "";
    let menu = JSON.parse(localStorage.getItem('menu'));

    menu.forEach((item) =>{
        if (item.label === menuOption){
            icon = item.icon;
        }
    });
    return icon;
}